import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModalComponent } from './ui-modal/ui-modal.component';
import { UiModalPickerComponent } from './ui-modal-picker/ui-modal-picker.component';
import { AnimationModalComponent } from './animation-modal/animation-modal.component';

@NgModule({
    imports: [CommonModule],
    declarations: [UiModalComponent, UiModalPickerComponent, AnimationModalComponent],
    exports: [UiModalComponent, UiModalPickerComponent, AnimationModalComponent],
})
export class ModalModule {}
